import { createSlice } from "@reduxjs/toolkit";
import {
    startUILoading,
    stopUILoading,
} from "../../actions/administrador/ui/ui";
import { Call } from "../../../helpers/fetch";
import { errorHandler } from "../../../helpers/errorHandler";
import Swal from "sweetalert2";
import { startRenew } from "../../actions/administrador/auth/auth";
import {
    startStudentSetActive,
    startUpdatePositiveBalance,
} from "../../actions/students/students";
import { cloneWith } from "lodash";

const initialState = {
    pagination: {
        data: [],
        per_page: 10,
    },
    servicesByStudent: [],
    list: [],
    showModal: false,
    active: null,
};

export const scholarServices = createSlice({
    name: "scholarServices",
    initialState,
    reducers: {
        setServicesByStudent: (state, action) => {
            state.servicesByStudent = action.payload;
        },
        setList: (state, action) => {
            state.list = action.payload;
        },
        setSetActive: (state, action) => {
            state.active = action.payload;
        },
        startUnsetActive: (state) => {
            state.active = null;
        },
        openModal: (state) => {
            state.showModal = true;
        },
        closeModal: (state) => {
            state.showModal = false;
        },
        setPagination: (state, action) => {
            state.pagination = action.payload;
        },
        clearPagination: (state) => {
            state.pagination = initialState.pagination;
        },
    },
});

export const {
    setList,
    setSetActive,
    startUnsetActive,
    openModal,
    closeModal,
    setServicesByStudent,
    setPagination,
    clearPagination,
} = scholarServices.actions;
export default scholarServices.reducer;

// Actions

export const startGetAllServices = ({
    showOnlyExtraServices = false,
    showOnlyDiplomaServices = null,
    showOnlyTallerDeTesisServices = null,
    showOnlySolicitableServices = null,
} = {}) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const params = new URLSearchParams();

        if (showOnlyExtraServices) {
            params.set("showOnlyExtraServices", 1);
        }

        if (showOnlyDiplomaServices !== null) {
            params.set(
                "showOnlyDiplomaServices",
                showOnlyDiplomaServices ? 1 : 0
            );
        }

        if (showOnlyTallerDeTesisServices !== null) {
            params.set(
                "showOnlyTallerDeTesisServices",
                showOnlyTallerDeTesisServices ? 1 : 0
            );
        }

        if (showOnlySolicitableServices !== null) {
            params.set(
                "showOnlySolicitableServices",
                showOnlySolicitableServices ? 1 : 0
            );
        }

        const resp = await Call(
            `students/services/all`,
            "GET",
            params.toString()
        );

        if (resp.success) {
            dispatch(setList(resp.success));
        } else {
            // errorHandler(resp, setErrors);
        }
        dispatch(stopUILoading());
    };
};

export const startGetAllSolicitableServices = () => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call(`students/services/all-solicitable`, "GET");

        if (resp.success) {
            dispatch(setList(resp.success));
        } else {
            // errorHandler(resp, setErrors);
        }
        dispatch(stopUILoading());
    };
};

export const startGetServicesByStudentWithToken = () => {
    return async (dispatch) => {
        dispatch(startUILoading());
        const resp = await Call(`students/services/by/student`, "GET");
        if (resp.success) {
            dispatch(setServicesByStudent(resp?.success));
        } else {
            errorHandler(resp);
        }
        dispatch(stopUILoading());
    };
};

export const startGetServicesByStudentById = (id) => {
    return async (dispatch) => {
        dispatch(startUILoading());
        const resp = await Call(`students/services/by/student/${id}`, "GET");
        if (resp.success) {
            dispatch(setServicesByStudent(resp?.success));
        } else {
            errorHandler(resp);
        }
        dispatch(stopUILoading());
    };
};

export const startGetServicesByStudent = (values) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const params = new URLSearchParams();

        params.set("page", values.page);
        params.set("per_page", values.number_rows);
        if (values?.cycle_id) {
            params.set("cycle_id", values.cycle_id);
        }
        if (values?.status) {
            params.set("status", values.status);
        }
        if (values?.with_exam) {
            params.set("with_exam", values.with_exam);
        }

        const resp = await Call(
            `students/services/by/${values.academic_record}`,
            "GET",
            params.toString()
        );

        if (resp.success) {
            dispatch(setPagination(resp?.success?.data));
        } else {
            errorHandler(resp);
        }
        dispatch(stopUILoading());
    };
};

export const startDeleteServicesByStudent = (
    id,
    { academic_record, extraordinary_id = null },
    callback = () => {},
    setErrors
) => {
    return async (dispatch) => {
        const result = await Swal.fire({
            title: "¿Está seguro de eliminar?",
            icon: "warning",
            text: "No podrá revertir esta acción!",
            showCancelButton: true,
            cancelButtonText: "Cancelar",
            confirmButtonText: "Sí, eliminar",
            confirmButtonColor: "#2e4a6c",
            cancelButtonColor: "#6c757d",
            input: "text",
            inputLabel:
                "Escriba la palabra 'eliminar' para confirmar esta operación.",
            inputAttributes: {
                autocapitalize: "off",
            },
        });
        if (result.value === "eliminar") {
            dispatch(startUILoading());

            const params = {
                extraordinary_id,
            };

            const resp = await Call(
                `students/services/delete/by/${id}`,
                "DELETE",
                params
            );

            if (resp.success) {
                Swal.fire({
                    title: "Éxito",
                    text: "Eliminación exitosa.",
                    icon: "success",
                    toast: true,
                    position: "bottom-end",
                    timer: 8000,
                });

                //* Se cambió por un callback
                callback();
                // dispatch(
                //     startGetServicesByStudent({ ...paginationScholarServices })
                // );

                academic_record.positive_balance.balance =
                    academic_record.positive_balance.balance +
                    resp.success.take_positive_balance;
                dispatch(
                    startStudentSetActive({
                        ...academic_record,
                    })
                );
            } else {
                errorHandler(resp);
            }
            dispatch(stopUILoading());
        }
    };
};

export const startCondonateSurcharges = (
    academicService,
    getData = () => {}
) => {
    return async (dispatch) => {
        const result = await Swal.fire({
            title: "Condonación de recargos",
            icon: "warning",
            text: "Esta acción habilita o deshabilita los recargos sobre este servicio",
            showCancelButton: true,
            cancelButtonText: "Habilitar recargos",
            confirmButtonText: "Condonar recargos",
            confirmButtonColor: "#2e4a6c",
            cancelButtonColor: "#6c757d",
        });

        const has_surcharges = result.isDismissed;

        dispatch(startUILoading());
        const resp = await Call(
            `students/services/has_surcharges/${academicService.id}`,
            "PUT",
            { has_surcharges }
        );

        if (resp.success) {
            getData();
        }
        dispatch(stopUILoading());
    };
};

export const startCreate = (
    values,
    {
        academic_record,
        extraordinary_id = null,
        graduation_option_request_id = null,
    },
    callback = () => {},
    setErrors
) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const params = {
            ...values,
            delete_on_expire: values.services,
            delete_on_expire: values.expiration_action == 2,
            generate_surcharges: values.expiration_action == 1,
            extraordinary_id,
            graduation_option_request_id,
            school_subject_id: values?.school_subject_id,
        };
        const resp = await Call(`students/services/create`, "POST", params);
        if (resp.success) {
            Swal.fire({
                title: "Éxito",
                text: "Registro exitoso.",
                icon: "success",
                toast: true,
                position: "bottom-end",
                timer: 8000,
            });
            // dispatch(startGetServicesByStudent(currentValues)); //* Se cambió por un callback
            callback(resp.success?.id);

            if (academic_record.positive_balance) {
                academic_record.positive_balance.balance =
                    academic_record.positive_balance.balance -
                    values.take_positive_balance;
            }
        } else {
            errorHandler(resp, setErrors);
        }
        dispatch(stopUILoading());
    };
};

export const startEdit = (
    service_id,
    { extraordinary_id = null },
    values,
    callback = () => {},
    setErrors
) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const params = {
            ...values,
            delete_on_expire: values.expiration_action == 2,
            generate_surcharges: values.expiration_action == 1,
            extraordinary_id,
        };

        const resp = await Call(
            `students/services/edit/${service_id}`,
            "POST",
            params
        );
        if (resp.success) {
            Swal.fire({
                title: "Éxito",
                text: "Registro actualizado con exito.",
                icon: "success",
                toast: true,
                position: "bottom-end",
                timer: 8000,
            });
            // dispatch(startGetServicesByStudent(currentValues)); //* Se cambió por un callback

            //* Actualizar el positive_balance del alumno en redux
            dispatch(
                startUpdatePositiveBalance(
                    resp.success.student_positive_balance
                )
            );
            callback();
        } else {
            errorHandler(resp, setErrors);
        }
        dispatch(stopUILoading());
    };
};

export const startAddNote = (
    service_id,
    values,
    callback = () => {},
    setErrors
) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call(
            `students/services/addNote/${service_id}`,
            "POST",
            values
        );

        if (resp.success) {
            callback();

            Swal.fire({
                title: "Éxito",
                text: "Nota registrada exitosamente.",
                icon: "success",
                toast: true,
                position: "bottom-end",
                timer: 8000,
            });
        } else {
            errorHandler(resp, setErrors);
        }
        dispatch(stopUILoading());
    };
};

export const startShowMigrationKey = (migrationKey) => {
    return async (dispatch) => {
        Swal.fire({
            title: "Llave de migración:",
            text: migrationKey,
            icon: "info",
            showClass: {
                popup: "animate__animated animate__fadeInDown",
            },
            hideClass: {
                popup: "animate__animated animate__fadeOutUp",
            },
        });
    };
};
